import { createApp } from 'vue'
import recyclePage from '@/pages/recycle/recycle-request.vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

createApp(recyclePage).use(VueReCaptcha, { siteKey: window.af_reCaptchaSiteKey }).mount('#form');
